export function LogoMark({ className = "w-9 h-9" }) {
  return (
    <div className={`rounded-xl bg-white flex items-center justify-center overflow-hidden shadow-sm ${className}`}>
      <img src="/futuregen-logo.png" alt="Futuregen Innovations" className="w-full h-full object-contain p-1" />
    </div>
  );
}

export const BRAND_NAME = "Futuregen Innovations";
export const BRAND_TAGLINE = "The future of regulated service compliance";
export const BRAND_PARENT = "In association with Futuregen Services Ltd";
